import request from "../libs/request";

export type ReportCategoryResponse = {
  [key: string]: string;
};

export const getReportCategory = () =>
  request.get<ReportCategoryResponse>("report/category");

export type ReportRequest = {
  lifePostId?: number;
  commentId?: number;
  createdBy?: number;
  reportCategory: string;
  content?: string;
};

export const addReport = (params: ReportRequest) =>
  request.post("report", params);
